<template>
  <v-row no-gutters class="fill-height flex-column" style="overflow-y: auto; overflow-x: hidden;">
    <v-col cols="12" class="pr-6">
      <card-title-row :straightTitle="$i18n.t('sidebar.locationSelection.title')" class="pt-5" />
      <v-form v-model="isValid" ref="form">
        <sidebar-form :inputs="inputs" v-model="params" :is-editing-on="!isStickyButtonsLoading" />
      </v-form>
    </v-col>
  </v-row>
</template>
<script>
import { call, get, sync } from 'vuex-pathify';
import CardTitleRow from '@/components/CardTitleRow';
import SidebarForm from '@/components/SidebarForm';
export default {
  name: 'LocationSelection',
  components: { CardTitleRow, SidebarForm },
  computed: {
    isStickyButtonsLoading: sync('sidebar/isStickyButtonsLoading'),
    isStickyButtonsValid: sync('sidebar/isStickyButtonsValid'),
    isStickyButtonsVisible: sync('sidebar/isStickyButtonsVisible'),
    stickyButtons: sync('sidebar/stickyButtons'),
    projectElements: get('layers/project@layers'),
    projectLayers() {
      return this.$_getFlatGroupsLayers(this.projectElements).layers;
    },
    projectVectorLayers() {
      return this.projectLayers.filter(layer => layer.type === 'features_layer');
    },
    inputs() {
      return [
        {
          name: 'layer',
          dataType: { name: 'select' },
          items: this.projectVectorLayers.filter(layer => layer.id !== this.params.relation_layer),
          itemValue: 'id',
          itemText: 'name',
          translationPath: 'sidebar.locationSelection.selectFeaturesFromLayer',
          cols: '7',
          nameCols: '5',
          rules: [v => !!v || v === 0 || 'rules.required'],
          hideRulesIcon: true,
        },
        {
          name: 'operation',
          dataType: { name: 'select' },
          items: [
            { value: 'within', text: this.$i18n.t('sidebar.locationSelection.include') },
            { value: 'intersects', text: this.$i18n.t('sidebar.locationSelection.intersect') },
          ],
          translationPath: 'sidebar.locationSelection.which',
          cols: '7',
          nameCols: '5',
          rules: [v => !!v || v === 0 || 'rules.required'],
          hideRulesIcon: true,
        },
        {
          name: 'relation_layer',
          dataType: { name: 'select' },
          items: this.projectVectorLayers.filter(layer => layer.id !== this.params.layer),
          itemValue: 'id',
          itemText: 'name',
          translationPath: 'sidebar.locationSelection.withFeaturesFromLayer',
          cols: '7',
          nameCols: '5',
          rules: [v => !!v || v === 0 || 'rules.required'],
          hideRulesIcon: true,
        },
      ];
    },
  },
  data: () => ({
    isValid: false,
    params: {
      layer: null,
      relation_layer: null,
      operation: '',
    },
  }),
  methods: {
    getLocationSelection: call('layers/getLocationSelection'),
    deleteFeature(id, layerId = this.currentManholesLayerId) {
      const deletedIds = id ? [id] : [];
      this.$store.set('map/DELETE_SELECTED_FEATURES!', {
        type: 'selectedFeatures',
        features: {
          [layerId]: deletedIds,
        },
      });
    },
    selectFeatures(layerId, results) {
      this.$store.set('map/ADD_SELECTED_FEATURES!', {
        type: 'selectedFeatures',
        features: {
          [layerId]: results,
        },
      });
    },
    reset() {
      this.params = {
        layer: null,
        relation_layer: null,
        operation: '',
      };
      this.$refs.form.resetValidation();
      if (this.$route.name !== 'locationSelection') {
        this.$router.push({ name: 'locationSelection' });
      }
    },
    async runSelection() {
      this.isStickyButtonsLoading = true;
      const r = await this.getLocationSelection(this.params);
      if (r.length > 0) {
        this.result = r;
        if (this.$route.params.lid) {
          this.deleteFeature(this.params.layer, null);
          this.selectFeatures(this.params.layer, this.result);
        } else {
          this.$router.push({
            name: 'locationSelectionLayer',
            params: { lid: this.params.layer },
          });
        }
      } else {
        this.$store.set('snackbar/PUSH_MESSAGE!', {
          message: this.$i18n.t('snackbar.locationSelectionNotFound'),
        });
      }
      this.isStickyButtonsLoading = false;
    },
  },
  watch: {
    'params.layer'() {
      if (this.$route.name === 'locationSelectionLayer') {
        this.$router.push({ name: 'locationSelection' });
      }
    },
    isValid: {
      immediate: true,
      handler(nV) {
        this.isStickyButtonsValid = nV;
      },
    },
  },
  mounted() {
    this.$root.$off('runSelection');
    this.$root.$off('reset');
    this.$root.$on('runSelection', this.runSelection);
    this.$root.$on('reset', this.reset);
    this.stickyButtons = [
      {
        action: 'runSelection',
        translationPath: 'button.turnOn',
      },
      {
        action: 'reset',
        translationPath: 'button.reset',
        cancel: true,
      },
    ];
    this.isStickyButtonsLoading = false;
    this.isStickyButtonsValid = false;
    this.isStickyButtonsVisible = true;
    this.$root.$on('tableDataRowsFetched', () => {
      this.selectFeatures(this.params.layer, this.result);
    });
  },
  beforeDestroy() {
    this.isStickyButtonsVisible = false;
    this.$root.$off('tableDataRowsFetched');
  },
};
</script>
